


























import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'

@Component({
  components: { Icon },
  props: {
    size: {
      type: Number,
      default: 2
    },
    iconLeft: {
      type: String,
      default: 'arrow-left'
    },
    iconRight: {
      type: String,
      default: 'arrow-right'
    }
  }
})
export default class Carousel extends Vue {
  page: number = 0
  totalPages: number = 0

  get ableToGoLeft () {
    return this.page > 1
  }

  get ableToGoRight () {
    return this.page < this.totalPages
  }

  get width () {
    const wrapper: any = this.$refs.itemsWrapperRef
    const wrapperRect: any = wrapper.getBoundingClientRect()
    return wrapperRect.width / this.$props.size
  }

  mounted () {
    this.setup()
  }

  updated () {
    this.setup()
  }

  setup () {
    const container: any = this.$refs.itemsRef
    const size: number = this.$props.size
    const items: any[] = container.querySelectorAll('.carousel-item')
    if (items.length === 0) {
      return
    }

    this.totalPages = Math.ceil(items.length / size)
    this.page = this.page === 0 ? 1 : this.page
    items.forEach((item: any) => {
      item.style.minWidth = `${this.width}px`
      item.style.width = `${this.width}px`
    })
  }

  moveRight () {
    if (this.ableToGoRight) {
      this.page++
      const container: any = this.$refs.itemsRef
      container.style.left = `-${(this.page - 1) * 100}%`
      this.$forceUpdate()
    }
  }

  moveLeft () {
    if (this.ableToGoLeft) {
      this.page--
      const container: any = this.$refs.itemsRef
      container.style.left = `-${(this.page - 1) * 100}%`
      this.$forceUpdate()
    }
  }
}
